/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_No_DataInputs */

const en_general_no_data = /** @type {(inputs: General_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data available`)
};

const de_general_no_data = /** @type {(inputs: General_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Daten verfügbar`)
};

/**
* | output |
* | --- |
* | "No data available" |
*
* @param {General_No_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_no_data = /** @type {((inputs?: General_No_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_No_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_no_data(inputs)
	return de_general_no_data(inputs)
});